import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { queryKeyes } from 'shared/queryKeys';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '..';
import { loadCompletedReports, checkEditPermission, Get } from 'VesselMaster/vesselMaster.hooks';
import { Button, Card, CardBody, CardFooter, CardHeader, Col, Input, Label, Modal, Row } from 'reactstrap';
import ToolTip from 'Components/ToolTip';
import ViewReport from '../Media/VD2.png'
import ViewReportModal from '../Components/ViewReportModal';
import VesselTableHeadComponent from './VesselTableHeadComponent';
import PageNavButton from 'Dashboard/PendingFiles/PageNavButton';
import PopOver from 'Components/PopOver';
import { errorToast, successToast } from 'Components/Toasts';
import apiGlobal from 'global/api.global';
import ErrorComponent from 'Components/ErrorComponent';
import EditIcon from '../Media/ED2.png';
import { offlineEditStatus, Order, Roles } from 'shared/constants';
import { hasRole } from 'utils/auth/authUtils';
import Message from 'Components/Message';
import { OfflineFileStatus } from 'shared/constants';
import env from 'environment_system/env_system';
import { getConfigurationLimitsAction, getCurrentReportAction, getCurrentReportFilesAction, setReportID, setVesselState, VesselState } from 'Store/Generic/ReportingSlice';
import PopUp from 'Components/PopUp';
import InsertReportPopUp from './EditCompletedReports/InsertReportPopUp';
import { queryClient } from 'react-query/queryClient';
import EditPermissionPopUP from './EditPermissionPopUP';
import ImportStatusReport from './ImportStatusReport';
import { checkValidArray, dateTimeFormat, formattooltip, generateReportName } from 'GenericForms/Helper';
import { fileTypeConstant, jsonImportStatus } from 'shared/constants';
import TableLoading from 'Components/TableLoading';
// import DeletePopOver from 'Components/DeletePopOver';
// import DeleteVoyagePopUp from './DeleteVoyagePopUp';
import { GrantEditAccess } from './GrantEditAccess';
import BaseButton from 'Components/BaseButton';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import ErrorTooltip from 'Components/ErrorTooltip';
// import ReportExtraActions from 'Components/ReportExtraActions';

interface CompletedReportsInterface {
    isPreviousVoyage?: boolean;
}

/**
 * CompletedReports component displays vessel reporting information, allows viewing reports,
 * sending emails to selected recipients, and managing report actions for a voyage.
 * @param {CompletedReportsInterface} props - Props containing isPreviousVoyage flag
 */
const CompletedReports = ({ isPreviousVoyage }: CompletedReportsInterface) => {
    /** State variables start */
    const { VoyageID, VesselID } = useSelector((state: RootState) => state.Reporting);
    // const voyage = Voyages.find((rec: any) => rec.id === VoyageID);
    const [viewReport, setViewReport] = useState(false);
    const [vesselId, setVesselId] = useState(0);
    const [reportId, setReportId] = useState(0);
    const [hoverId, setHoverId] = useState<string | null>(null)
    const [pageURL, setPageURL] = useState("");
    const [PopOverState, setPopOverState] = useState(false);
    const [cachedReports, setCachedReports] = useState<any>(null);
    const [initialLoadComplete, setInitialLoadComplete] = useState(false);
    const [unLockBool, setUnlockBool] = useState<boolean>(false);
    const [insertReport, setInsertReport] = useState<boolean>(false);
    const [reportid, setReportid] = useState<number>(0);
    const [viewDetailsReportId, setViewDetailsReportId] = useState<number | null>(null);
    // const [target, setTarget] = useState<string>('');
    const [isEditing, setisEditing] = useState();
    const [isOngoingReport, setIsOngoingReport] = useState<boolean>(false);
    const [UnlockMode, setUnlockMode] = useState<'edit' | 'add' | ''>('');
    const [importStatus, setImportStatus] = useState<boolean>(false);
    const [fileModelBool, setFileModelBool] = useState(false);
    const [currentReport, setCurrentReport] = useState<any>(null);
    const dispatch = useDispatch();
    // const [deletePopOverState, setDeletePopOverState] = useState(false);
    // const [deleteTarget, setDeleteTarget] = useState<string>("");
    // const [deleteReportObj, setDeleteReportObj] = useState<any>({});
    // const [changeVoyageBool, setChangeVoyageBool] = useState(false);
    // const [changeVoyageErrorBool, setChangeVoyageErrorBool] = useState(false);
    // const [updatedVoyage, setUpdatedVoyage] = useState(null);
    // const [RefreshKey, setRefreshKey] = useState(0);
    // const [deleteVoyage, setDeleteVoyage] = useState(false);
    // const [deleteVoyageReport, setDeleteVoyageReport] = useState(false);
    const [emailRecipientModal, setEmailRecipientModal] = useState(false);
    const [selectedRecipients, setSelectedRecipients] = useState<any[]>([]);
    const [showAddEmail, setShowAddEmail] = useState(false);
    const [addEmailButton, setAddEmailButton] = useState(true);
    const [requestEditBool, setRequestEditBool] = useState(false);
    const [spinnerBool, setSpinnerBool] = useState(false);
    const [order, setOrder] = useState<string>(Order.ASC);
    const extraActionsTooltipRef = React.useRef<HTMLSpanElement | null>(null);
    /** State variables end */
    /**
     * Sets the vessel state globally in Redux store for the selected report.
     * @param reportId - ID of the report
     * @param record - VesselState object
     */
    const handleVesselState = (reportId: number, record: VesselState) => {
        dispatch(setReportID(reportId))
        dispatch(setVesselState(record))
    }

    /**
     * useEffect to set page url
     */
    /**
     * Updates the page URL whenever VesselID or VoyageID changes.
     */
    useEffect(() => {
        setPageURL(queryKeyes.pagination.completeReportPage.url(VesselID, VoyageID, order));
    }, [VesselID, VoyageID, order]);
    /**
     * Invalidates edit permission and ongoing report queries on mount.
     */
    useEffect(() => {
        queryClient.invalidateQueries(queryKeyes.edit.checkongoingReport.key);
        queryClient.invalidateQueries(queryKeyes.edit.checkEditPermission.key);
    }, [])

    /** useQueries */
    /**
    * function returns Vessel Voyage Reporting information 
    * function returns Vessel Voyage Reporting information 
    * @param number VesselID
    * @param number VoyageID
    * @returns mix
    */
    /**
     * Fetches completed reports for the vessel and voyage, updates cached reports on success.
     */
    const { data: reports, isLoading: reportsFetching, isError: reportsError, refetch } = useQuery(
        [queryKeyes.pagination.completeReportPage.key, VesselID, VoyageID, pageURL],
        async () => { return await loadCompletedReports(VesselID, VoyageID, pageURL) },
        {
            enabled: true,
            onSuccess: (data) => {
                setInitialLoadComplete(true);
                // Update cached reports when new data arrives
                if (data?.results?.length > 0) {
                    setCachedReports(data);
                }
            }
        }
    );
    /**fetch all reports */
    // const { data: allReports, isLoading: reportsLoading } = useQuery(
    //     [queryKeyes.vessel.vesselVoyageReporting.key, VesselID, VoyageID],
    //     async () => { return await Get(queryKeyes.vessel.vesselVoyageReporting.url(VesselID, VoyageID), VesselID, VoyageID) },
    //     { staleTime: Infinity }
    // )
    /**
     * Fetch organization configuration
     * @returns organizationConfiguration
     */
    const { data: organizationConfiguration } = useQuery(
        [queryKeyes.organization.OrganizationConfiguration.key],
        async (): Promise<any> => { return await Get(queryKeyes.organization.OrganizationConfiguration.url()) },
        {
            enabled: true,
            staleTime: Infinity
        }
    );
    /**
     * Fetch email reporting object
     * @param VesselID
     * @returns emailReportingObjectFiltered
     */
    const { data: emailReportingObject } = useQuery(
        [queryKeyes.vessel.VesselReportingEmail.key, VesselID],
        async () => {
            return await Get(queryKeyes.vessel.VesselReportingEmail.url(VesselID), VesselID);
        },
        { staleTime: Infinity }
    );
    const emailReportingObjectFiltered = checkValidArray(emailReportingObject)
        ? emailReportingObject.filter((obj: any) => {
            return obj?.email_type?.find((type: number) => type === 2 || type === 3);
        })
        : [];
    /**
     * Returns the initial email recipient object for the send mail modal.
     * Filters valid email objects and maps them to the required structure.
     */
    const SendMailInitialObject = () => {
        if (checkValidArray(emailReportingObjectFiltered)) {
            return {
                emails: emailReportingObjectFiltered.map((obj: any) => ({
                    email: obj.email || "",
                    name: obj.name || "",
                    vessel_reporting_information: reportId || null,
                }))
            };
        }
    }
    /**
     *  Offline file status
     * @param VoyageID
     * @returns offlineFileStatus
     */
    const { data: offlineFileStatus } = useQuery(
        [queryKeyes.vessel.offlineFileStatus.key, VoyageID],
        async () => {
            return await Get(queryKeyes.vessel.offlineFileStatus.url(VoyageID), VoyageID);
        },
        {
            staleTime: Infinity,
            enabled: env.offlineCopy
        }
    );
    const { isLoading: ongoingReportLoading } = useQuery(
        VesselID ? [queryKeyes.edit.checkongoingReport.key, VesselID] : [],
        () => Get(queryKeyes.edit.checkongoingReport.url(VesselID), VesselID),
        {
            enabled: !!VesselID, // Ensures query runs only when VesselID is available
            staleTime: 0, // Force refetch every time VesselID changes
            onSuccess: (data) => {
                setIsOngoingReport(data?.completion_status);
            },
            onError: () => {
                setIsOngoingReport(true);
            }
        }
    );
    /**
     * get import report status record by voyage
     * @param VoyageID
     * @returns importReportStatus
     */
    const { data: importReportStatus } = useQuery(
        [queryKeyes.vessel.importReportStatus.key, VoyageID],
        async () => await Get(queryKeyes.vessel.importReportStatus.url(VoyageID), VoyageID),
        {
            staleTime: 0,
            enabled: env.offlineCopy
        }
    );
    const { isLoading: editPermissionLoading } = useQuery(
        [queryKeyes.edit.checkEditPermission.key, VesselID],
        async () => { return await checkEditPermission(VesselID, false) },
        {
            staleTime: Infinity,
            onSuccess: (data) => {
                setisEditing(data.status);
            }
        }
    )
    // const { data: lastVesselReport } = useQuery(
    //     [queryKeyes.vessel.LastVesselReport.key, VesselID],
    //     async () => await Get(queryKeyes.vessel.LastVesselReport.url(VesselID), VesselID),
    //     {
    //         staleTime: Infinity
    //     }
    // )

    /** Load Vessel master data by vessel id */
    const {
        data: VesselData,
        isLoading: VesselDataLoading,
        isError: VesselDataError,
    }: { data: any; isLoading: any; isError: any } = useQuery(
        [queryKeyes.masters.VesselMasterByID.key, VesselID],
        async () => {
            return await Get(queryKeyes.masters.VesselMasterByID.url(VesselID), VesselID);
        },
        {
            enabled: !!VesselID,
            staleTime: Infinity,
        }
    );
    /** useQueries end */

    // Determine which data to display - use current data if available, otherwise use cached data
    const displayData = reports || cachedReports;
    const page = displayData?.results;
    /**
     * Opens the view report modal for the selected report.
     * @param id - Report ID to view
     */
    const handleViewChanges = (id: number) => {
        setViewReport(true);
        setReportId(id);
    }

    /**
     * Sends an email for the given vessel and report ID using the backend API.
     * Displays a success or error toast based on the response.
     * @param vesselId - Vessel ID
     * @param reportId - Report ID
     */
    function sendEmail(vesselId: number, reportId: number) {
        setPopOverState(false); // Ensure this executes regardless of success or failure
        return apiGlobal.post(`manually_send_daily_reporting_email/`, {
            vessel_id: vesselId,
            report_id: reportId,
        })
            .then(res => {
                // Check if the response is successful
                if ((res.status === 201 || res.status === 200) && res?.data?.state === true) {
                    const successMessage = res?.data?.message || "Email sent successfully!";
                    successToast(successMessage); // Display success message from response if available
                }
            })
            .catch(err => {
                // Extract the most useful error message
                const errorMessage =
                    err?.response?.data?.error ||  // Custom API error message
                    err?.response?.data?.message ||
                    err?.response?.statusText ||   // Default HTTP status text
                    err?.message ||                // Generic error message from Axios
                    "An unknown error occurred";   // Fallback message
                errorToast(errorMessage); // Show the error message in a toast
            });
    }

    // Show loading indicator only during initial load
    const showLoadingIndicator = reportsFetching && !initialLoadComplete && !editPermissionLoading && !ongoingReportLoading && !VesselDataLoading;
    const unlockReport = (reportId: number) => {
        apiGlobal.get(queryKeyes.vessel.unlockReport.url(reportId, UnlockMode))
            .then(async (res) => {
                if (res.status === 200) {
                    successToast("Report unlocked successfully!");
                    await queryClient.invalidateQueries([queryKeyes.pagination.completeReportPage.key, VesselID]);
                    await refetch();
                } else {
                    errorToast("Failed to unlock report.");
                }
            })
            .catch((error) => {
                console.error("Error unlocking report:", error);
                errorToast("Something went wrong while unlocking the report.");
            });
        setUnlockBool(false);
    };

    // Show modal when Email icon is clicked
    /**
     * Handles click on the email icon for a report.
     * Opens the email recipient modal and resets the email list.
     * @param report - The report object
     */
    const handleEmailIconClick = (report: any) => {
        setReportId(report.id);
        setVesselId(report.vessel);
        setEmailRecipientModal(true);
        // Reset email list to latest from backend
        const initial = SendMailInitialObject();
        setEmailList(initial?.emails || []);
        setSelectedRecipients([]);
    };

    // Send email to selected recipients
    /**
     * Sends email to the selected recipients using the backend API.
     * Closes the modal and displays a toast based on the response.
     * @param emails - Array of recipient email objects
     */
    const handleSendEmailToRecipients = (emails: any[]) => {
        const payload = emails.map(e => ({
            email: e.email,
            name: e.name,
            vessel_reporting_information: reportId,
        }));

        setEmailRecipientModal(false);
        apiGlobal.post(`manually_send_daily_reporting_email/`, payload)
            .then(res => {
                if ((res.status === 201 || res.status === 200) && res?.data?.state === true) {
                    successToast(res?.data?.message || "Email sent successfully!");
                }
            })
            .catch(err => {
                const errorMessage =
                    err?.response?.data?.error ||
                    err?.response?.data?.message ||
                    err?.response?.statusText ||
                    err?.message ||
                    "An unknown error occurred";
                errorToast(errorMessage);
            });
    };
    /**
     * Adds a new email entry to the local email list for the modal. Validates input and resets modal state after adding.
     * @param {*} values
     * @returns
     */
    const addEmailFormik = useFormik({
        initialValues: {
            name: "",
            email: "",
        },
        validationSchema: Yup.object().shape({
            name: Yup.string().trim().required("Name is required"),
            email: Yup.string()
                .trim()
                .email("Invalid email format")
                .required("Email is required")
                .test("unique", "This email address has already been added.", function (value) {
                    if (!value) return true;
                    const lowerEmail = value.toLowerCase();
                    return !emailList.some((entry: any) => entry.email.toLowerCase() === lowerEmail);
                }),
        }),
        onSubmit: (values: any, { resetForm }: any) => {
            const newEntry = {
                name: values.name.trim(),
                email: values.email.trim(),
                vessel_reporting_information: reportId,
                isTemporary: true,
            };
            setEmailList((prev: any) => [...prev, newEntry]);
            setSelectedRecipients((prevSelected) => [...prevSelected, emailList.length]);
            setShowAddEmail(false);
            setAddEmailButton(true);
            successToast("Temporary email added");
            resetForm();
        },
    });

    const [emailList, setEmailList] = useState(() => {
        const initial = SendMailInitialObject();
        return initial?.emails || [];
    });

    const returnEditButtonLable = (edit_status: any) => {
        switch (edit_status) {
            case offlineEditStatus.OFFLINE_GRANT_EDIT_ACCESS:
                return "Grant Edit Access";

            case offlineEditStatus.OFFLINE_EDIT_REPORT_ACTIVATED:
                return "Edit Report activated";

            case offlineEditStatus.SERVER_EDIT_SESSION_ENABLED:
                return "Start Edit Session";

            case offlineEditStatus.SERVER_ONGOING_EDIT_ACTIVITY:
                return "End Edit Session";

            case offlineEditStatus.SERVER_EDIT_COMPLETE:
                return "Edit session Complete";

            default:
                return "Request Edit";
        }
    };

    const handleOfflineEditAccess = (edit_status: any) => {
        setSpinnerBool(true);
        if (edit_status === offlineEditStatus.OFFLINE_GRANT_EDIT_ACCESS) {
            apiGlobal.post(`/grant_edit_access_to_server/`, {
                vuid: VesselData?.vuid,
            }).then(async res => {
                if (res?.status === 200) {
                    successToast("Edit permission successfully granted");
                    await queryClient.invalidateQueries(queryKeyes.masters.VesselMasterByID.key);
                    await queryClient.invalidateQueries(queryKeyes.masters.VesselMaster.key);
                    setSpinnerBool(false);
                }
            }).catch(() => {
                errorToast("Error while granting permission!");
                setSpinnerBool(false);
            });
        }

        if (edit_status === offlineEditStatus.OFFLINE_EDIT_REPORT_ACTIVATED) {
            apiGlobal.post(`/check_edit_status_from_server/`, {
                vuid: VesselData?.vuid,
            }).then(async res => {
                if (res?.status === 200) {
                    successToast(res.data.message);
                    await queryClient.invalidateQueries(queryKeyes.masters.VesselMasterByID.key);
                    setSpinnerBool(false);
                }
            }).catch(() => {
                errorToast("Error while granting permission!");
                setSpinnerBool(false);
            });
        }

        if (edit_status === offlineEditStatus.SERVER_EDIT_SESSION_ENABLED) {
            apiGlobal.patch(`${queryKeyes.masters.VesselMaster.url()}${VesselID}/`, {
                offline_edit_status: offlineEditStatus.SERVER_ONGOING_EDIT_ACTIVITY,
            }).then(async res => {
                if (res?.status === 200) {
                    successToast("Editing enabled sucessfully");
                    await queryClient.invalidateQueries(queryKeyes.masters.VesselMasterByID.key);
                    setSpinnerBool(false);
                }
            }).catch(() => {
                errorToast("Unable to give edit access");
                setSpinnerBool(false);
            });
        }

        if (edit_status === offlineEditStatus.SERVER_ONGOING_EDIT_ACTIVITY) {
            apiGlobal.patch(`${queryKeyes.masters.VesselMaster.url()}${VesselID}/`, {
                offline_edit_status: offlineEditStatus.SERVER_EDIT_COMPLETE,
            }).then(async res => {
                if (res?.status === 200) {
                    successToast("Editing completed successfully");
                    await queryClient.invalidateQueries(queryKeyes.masters.VesselMasterByID.key);
                    setSpinnerBool(false);
                }
            }).catch(() => {
                errorToast("Unable to complete edit");
                setSpinnerBool(false);
            });
        }
    }

    return (
        <CardBody className='p-0'>
            {!isPreviousVoyage &&
                <div className='ele_row mb-2'>
                    <h4 id='owner_table' className='mb-3'>Vessel Reporting Information</h4>
                    {VesselData?.is_vessel_offline && VesselData?.offline_edit_status !== offlineEditStatus.SERVER_EDIT_SESSION_DISABLED &&
                        <Button
                            className='primary'
                            color='primary'
                            id='offline_edit_btn'
                            disabled={
                                VesselData?.offline_edit_status === offlineEditStatus.SERVER_EDIT_COMPLETE
                            }
                            onClick={() => {
                                VesselData?.offline_edit_status === offlineEditStatus.OFFLINE_GRANT_EDIT_ACCESS ?
                                    setRequestEditBool(true) :
                                    handleOfflineEditAccess(VesselData?.offline_edit_status)

                            }}
                        >
                            {spinnerBool && <span className="spinner-border spinner-border-sm me-2" />}
                            {returnEditButtonLable(VesselData?.offline_edit_status)}
                        </Button>
                    }
                </div>}
            {showLoadingIndicator && (
                <TableLoading />
            )}
            {(reportsError || VesselDataError) && (
                <ErrorComponent message={'Unable to load required data!'} />
            )}
            {!((reportsError || VesselDataError) && showLoadingIndicator) && (
                <table className="table mb-0">
                    <VesselTableHeadComponent reportStatus="completed" tab={2} setOrder={setOrder} order={order} />
                    <tbody>
                        {page ? (page?.map((report: any, index: number) => (
                            <tr key={`completed_${report.id}_report`}>
                                <td className="p-2 align-middle text-center">{index + 1}</td>
                                <td className="p-2 align-middle">{`${generateReportName(report)} (${report.reporting_type})`}</td>
                                <td className="p-2 align-middle text-center">{dateTimeFormat(report?.local_time, false, false, true)}</td>
                                <td className="p-0 align-middle text-center">
                                    <div className='d-flex align-items-center justify-content-center gap-3'>
                                        <img
                                            alt="View Report"
                                            className='align-middle pointer'
                                            src={ViewReport}
                                            height="28"
                                            id={`view_details_${report.id}`}
                                            onMouseEnter={() => setHoverId(`view_details_${report.id}`)}
                                            onMouseLeave={() => setHoverId(null)}
                                            onClick={() => {
                                                handleViewChanges(report.id)
                                                setHoverId(null);
                                            }}
                                        />
                                        {(env.offlineCopy && importReportStatus?.length > 0 && importReportStatus?.some((jsonObj: any) => jsonObj.offline_report_id === report.id))
                                            ? importReportStatus?.map((jsonObj: any) =>
                                                jsonObj.offline_report_id === report.id ? (
                                                    <>
                                                        <i
                                                            id={(() => {
                                                                if (jsonObj.current_offline_stage === jsonImportStatus.PENDING) {
                                                                    return `report_upload_pending_${report.id}`;
                                                                } else if (jsonObj.current_offline_stage === jsonImportStatus.UPLOADED) {
                                                                    return `report_is_currently_uploaded_${report.id}`;
                                                                } else if (jsonObj.current_offline_stage === jsonImportStatus.PROCESSING) {
                                                                    return `report_is_processing_${report.id}`;
                                                                } else if (jsonObj.current_offline_stage === jsonImportStatus.COMPLETED) {
                                                                    return `report_sync_completed_${report.id}`;
                                                                } else if (jsonObj.current_offline_stage === jsonImportStatus.REJECTED) {
                                                                    return `report_sync_failed_${report.id}`;
                                                                }
                                                                return `report_status_unknown_${report.id}`;
                                                            })()} // Dynamically computing id
                                                            className={`ps-2 pe-3 bx bx-sm icon_s32 color-assign-user align-middle ${jsonObj.current_offline_stage === jsonImportStatus.PENDING ? "dripicons-clock" :
                                                                jsonObj.current_offline_stage === jsonImportStatus.UPLOADED ? "dripicons-cloud-upload" :
                                                                    jsonObj.current_offline_stage === jsonImportStatus.PROCESSING ? "dripicons-loading" :
                                                                        jsonObj.current_offline_stage === jsonImportStatus.COMPLETED ? "dripicons-checkmark" :
                                                                            jsonObj.current_offline_stage === jsonImportStatus.REJECTED ? "dripicons-cross" :
                                                                                "dripicons-clock"
                                                                }`}
                                                            onMouseEnter={() => {
                                                                let hoverText = `report_status_unknown_${report.id}`;
                                                                if (jsonObj.current_offline_stage === jsonImportStatus.PENDING) {
                                                                    hoverText = `report_upload_pending_${report.id}`;
                                                                } else if (jsonObj.current_offline_stage === jsonImportStatus.PROCESSING) {
                                                                    return `report_is_processing_${report.id}`;
                                                                } else if (jsonObj.current_offline_stage === jsonImportStatus.UPLOADED) {
                                                                    hoverText = `report_is_currently_uploaded_${report.id}`;
                                                                } else if (jsonObj.current_offline_stage === jsonImportStatus.COMPLETED) {
                                                                    hoverText = `report_sync_completed_${report.id}`;
                                                                } else if (jsonObj.current_offline_stage === jsonImportStatus.REJECTED) {
                                                                    hoverText = `report_sync_failed_${report.id}`;
                                                                }
                                                                setHoverId(hoverText);
                                                            }}
                                                            onMouseLeave={() => setHoverId(null)}
                                                        />
                                                        <i
                                                            id={`view_sync_file_${report.id}`}
                                                            className="ps-3 pe-4 bx bx-sm icon_s32 color-assign-user align-middle dripicons-document pointer"
                                                            onClick={() => {
                                                                setFileModelBool(true)
                                                                setCurrentReport(report)
                                                            }} // Set report ID instead of boolean
                                                            onMouseEnter={() => setHoverId(`view_sync_file_${report.id}`)}
                                                            onMouseLeave={() => setHoverId(null)}
                                                        />
                                                    </>
                                                ) : null
                                            ) :
                                            (env.offlineCopy ?
                                                <>
                                                    <i
                                                        id={`report_status_unknown_${report.id}`}
                                                        className="ps-2 pe-3 bx bx-sm icon_s32 color-assign-user align-middle dripicons-clock"
                                                        onMouseEnter={() => setHoverId(`report_status_unknown_${report.id}`)}
                                                        onMouseLeave={() => setHoverId(null)}
                                                    />
                                                    <i
                                                        id={`view_sync_file_${report.id}`}
                                                        className="ps-3 pe-4 bx bx-sm icon_s32 color-assign-user align-middle dripicons-document pointer"
                                                        onClick={() => {
                                                            setFileModelBool(true)
                                                            setCurrentReport(report)
                                                        }} // Set report ID instead of boolean
                                                        onMouseEnter={() => setHoverId(`view_sync_file_${report.id}`)}
                                                        onMouseLeave={() => setHoverId(null)}
                                                    />
                                                </>
                                                : null
                                            )
                                        }
                                        <i
                                            className="bx bx-file-find align-middle icon_s32 color-assign-user"
                                            id={`View_Uploaded_Files_${report.id}`}
                                            onMouseEnter={() => setHoverId(`View_Uploaded_Files_${report.id}`)}
                                            onMouseLeave={() => setHoverId(null)}
                                            onClick={() => {
                                                handleVesselState(report.id, 'UPLOADED_FILES')
                                                dispatch(getCurrentReportAction(VesselID, report.id));
                                                setHoverId(null);
                                            }}
                                        />
                                        {!env.offlineCopy && (hasRole(Roles.ES_ADMIN)) && (
                                            <i
                                                className='fas fa-tasks align-middle icon_s23 color-assign-user'
                                                id={`Check_edit_status_${report.id}`}
                                                onMouseEnter={() => setHoverId(`Check_edit_status_${report.id}`)}
                                                onMouseLeave={() => setHoverId(null)}
                                                onClick={() => {
                                                    setImportStatus(true);
                                                    setHoverId(null);
                                                    setReportId(report.id);
                                                }}
                                            />
                                        )}
                                        {
                                            !env.offlineCopy &&
                                            (hasRole(Roles.ES_ADMIN) || hasRole(Roles.ADMIN)) && (
                                                !report.initial_report ? (
                                                    !report?.edit_permission ? (
                                                        <i
                                                            className="bx bx-lock align-middle icon_s32 color-assign-user"
                                                            id={`Locked_edit_report_${report.id}`}
                                                            onMouseEnter={() =>
                                                                setHoverId(`Locked_edit_report_${report.id}`)
                                                            }
                                                            onMouseLeave={() => setHoverId(null)}
                                                            onClick={() => {
                                                                if (hasRole(Roles.ES_ADMIN) || hasRole(Roles.MANAGER)) {
                                                                    setUnlockBool(true);
                                                                    // setTarget(`Locked_edit_report_${report.id}`);
                                                                    setUnlockMode('edit');
                                                                    setReportid(report.id);
                                                                }
                                                            }}
                                                        />
                                                    ) : (
                                                        (hasRole(Roles.ES_ADMIN) || hasRole(Roles.ADMIN)) && (
                                                            <img
                                                                src={EditIcon}
                                                                alt="Edit Icon"
                                                                height="28"
                                                                className="pointer"
                                                                id={`Edit_Details_${report.id}`}
                                                                onMouseEnter={() =>
                                                                    setHoverId(`Edit_Details_${report.id}`)
                                                                }
                                                                onMouseLeave={() => setHoverId(null)}
                                                                onClick={() => {
                                                                    dispatch(getConfigurationLimitsAction(VesselID));
                                                                    dispatch(
                                                                        getCurrentReportFilesAction(report.id, VesselID)
                                                                    );
                                                                    handleVesselState(report.id, 'EDIT_REPORTING');
                                                                }}
                                                            />
                                                        )
                                                    )
                                                ) : (
                                                    <i
                                                        className="bx bx-lock align-middle icon_s32 text-muted"
                                                        style={{ cursor: 'not-allowed', opacity: 0.5 }}
                                                        id={`Initial_report_can_not_be_edited_${report.id}`}
                                                        onMouseEnter={() =>
                                                            setHoverId(
                                                                `Initial_report_can_not_be_edited_${report.id}`
                                                            )
                                                        }
                                                        onMouseLeave={() => setHoverId(null)}
                                                        onClick={() => {
                                                            setHoverId(null);
                                                        }}
                                                    />
                                                )
                                            )
                                        }

                                        {!isPreviousVoyage && !env.offlineCopy && (
                                            <i
                                                className={`bx bx-mail-send pointer icon_s32 color-assign-user align-middle
                                                        ${organizationConfiguration && (organizationConfiguration[0]?.send_email_status === false || emailReportingObjectFiltered?.length === 0) ? "disabled-icon" : ""}`}
                                                id={(() => {
                                                    if (organizationConfiguration && organizationConfiguration[0]?.send_email_status === false && emailReportingObjectFiltered?.length > 0) {
                                                        return `Email_Sending_is_disabled_${report.id}`;
                                                    } else if (organizationConfiguration && organizationConfiguration[0]?.send_email_status && emailReportingObjectFiltered?.length === 0) {
                                                        return `Please_configure_email_list_to_send_the_report_over_the_email_${report.id}`;
                                                    } else if (organizationConfiguration && organizationConfiguration[0]?.send_email_status === false && emailReportingObjectFiltered?.length === 0) {
                                                        return `Email_Sending_is_disabled_${report.id}`;
                                                    }
                                                    return `send_email_${report.id}`;
                                                })()} // Immediately Invoked Function Expression (IIFE) to compute the id
                                                onMouseEnter={() => {
                                                    let hoverText = `send_email_${report.id}`;
                                                    if (organizationConfiguration && organizationConfiguration[0]?.send_email_status === false && emailReportingObjectFiltered?.length > 0) {
                                                        hoverText = `Email_Sending_is_disabled_${report.id}`;
                                                    } else if (organizationConfiguration && organizationConfiguration[0]?.send_email_status && emailReportingObjectFiltered?.length === 0) {
                                                        hoverText = `Please_configure_email_list_to_send_the_report_over_the_email_${report.id}`;
                                                    } else if (organizationConfiguration && organizationConfiguration[0]?.send_email_status === false && emailReportingObjectFiltered?.length === 0) {
                                                        hoverText = `Email_Sending_is_disabled_${report.id}`;
                                                    }
                                                    setHoverId(hoverText);
                                                }}
                                                onMouseLeave={() => setHoverId(null)}
                                                onClick={() => {
                                                    if (organizationConfiguration && (organizationConfiguration[0]?.send_email_status === false || emailReportingObjectFiltered?.length === 0)) return;
                                                    handleEmailIconClick(report);
                                                }}
                                            />
                                        )}
                                        {env.desktop_app === true && offlineFileStatus && offlineFileStatus?.some((jsonObj: any) => jsonObj.vessel_reporting_information === report.id) ? (
                                            offlineFileStatus?.map((jsonObj: any, index: number) =>
                                                jsonObj.vessel_reporting_information === report.id ? (
                                                    <i
                                                        key={index}
                                                        id={(() => {
                                                            if (jsonObj.status === OfflineFileStatus.PENDING) {
                                                                return `File_upload_pending_${report.id}`;
                                                            } else if (jsonObj.status === OfflineFileStatus.UPLOADING) {
                                                                return `File_is_currently_uploading_${report.id}`;
                                                            } else if (jsonObj.status === OfflineFileStatus.COMPLETED) {
                                                                return `File_upload_successful_${report.id}`;
                                                            } else if (jsonObj.status === OfflineFileStatus.FAILED) {
                                                                return `File_upload_failed_${report.id}`;
                                                            }
                                                            return `File_status_unknown_${report.id}`;
                                                        })()} // Dynamically computing id
                                                        className={`ps-4 bx bx-sm icon_s32 color-assign-user align-middle ${jsonObj.status === OfflineFileStatus.PENDING ? "dripicons-clock" :
                                                            jsonObj.status === OfflineFileStatus.UPLOADING ? "dripicons-loading" :
                                                                jsonObj.status === OfflineFileStatus.COMPLETED ? "dripicons-checkmark" :
                                                                    jsonObj.status === OfflineFileStatus.FAILED ? "dripicons-cross" :
                                                                        "dripicons-clock"
                                                            }`}
                                                        onMouseEnter={() => {
                                                            let hoverText = `File_status_unknown_${report.id}`;
                                                            if (jsonObj.status === OfflineFileStatus.PENDING) {
                                                                hoverText = `File_upload_pending_${report.id}`;
                                                            } else if (jsonObj.status === OfflineFileStatus.UPLOADING) {
                                                                hoverText = `File_is_currently_uploading_${report.id}`;
                                                            } else if (jsonObj.status === OfflineFileStatus.COMPLETED) {
                                                                hoverText = `File_upload_successful_${report.id}`;
                                                            } else if (jsonObj.status === OfflineFileStatus.FAILED) {
                                                                hoverText = `File_upload_failed_${report.id}`;
                                                            }
                                                            setHoverId(hoverText);
                                                        }}
                                                        onMouseLeave={() => setHoverId(null)}
                                                    />
                                                ) : null
                                            )
                                        ) : (env.desktop_app === true &&
                                            <i
                                                id={`File_status_unknown_${report.id}`}
                                                className="ps-4 bx bx-sm icon_s32 color-assign-user align-middle dripicons-clock"
                                                onMouseEnter={() => setHoverId(`File_status_unknown_${report.id}`)}
                                                onMouseLeave={() => setHoverId(null)}
                                            />
                                        )}
                                        {/* {
                                            (hasRole(Roles.ES_ADMIN) || hasRole(Roles.MASTER) || hasRole(Roles.ADMIN)) &&
                                            <ReportExtraActions
                                                report={report}
                                                index={index}
                                                setHoverId={setHoverId}
                                                setDeleteReportObj={setDeleteReportObj}
                                                setReportId={setReportId}
                                                reportId={reportId}
                                                lastVesselReport={lastVesselReport}
                                                allReports={allReports}
                                                page={page}
                                                setDeleteTarget={setDeleteTarget}
                                                setDeleteVoyageReport={setDeleteVoyageReport}
                                                setDeletePopOverState={setDeletePopOverState}
                                                setUpdatedVoyage={setUpdatedVoyage}
                                                setChangeVoyageBool={setChangeVoyageBool}
                                                setChangeVoyageErrorBool={setChangeVoyageErrorBool}
                                                reportStatus="completed"
                                                tooltipRef={extraActionsTooltipRef}
                                            />
                                        } */}
                                        {env.desktop_app === true &&
                                            <React.Fragment key={index}>
                                                {/* Modal Trigger Icon */}
                                                <i
                                                    className="ps-4 bx bx-sm icon_s32 color-assign-user align-middle dripicons-document"
                                                    onClick={() => setViewDetailsReportId(report.id)} // Set report ID instead of boolean
                                                />
                                                {/* Modal (Always Renders) */}
                                                <Modal
                                                    size="xl"
                                                    isOpen={viewDetailsReportId === report.id} // Open modal only for correct report
                                                    toggle={() => setViewDetailsReportId(null)}
                                                    backdrop="static"
                                                    id="staticBackdrop"
                                                >
                                                    <Card>
                                                        <CardHeader>
                                                            <h5 className="mb-0">File Status</h5>
                                                            <h2 className="mb-0">Report: {report.reporting_event_name}</h2>
                                                            <p>
                                                                Date: {report.local_time?.slice(0, 10)} {report.local_time?.slice(11, 16)}
                                                            </p>
                                                        </CardHeader>
                                                        <CardBody>
                                                            {offlineFileStatus && offlineFileStatus?.some((jsonObj: any) => jsonObj.vessel_reporting_information === report.id) ? (
                                                                <table className="table table-bordered table-hover">
                                                                    <thead>
                                                                        <tr>
                                                                            <th scope="col">#</th>
                                                                            <th scope="col">File Name</th>
                                                                            <th scope="col">Total Size</th>
                                                                            <th scope="col">Upload Size</th>
                                                                            <th scope="col">Status</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {offlineFileStatus
                                                                            ?.filter((jsonObj: any) => jsonObj.vessel_reporting_information === report.id)
                                                                            ?.map((jsonObj: any, index: number) => (
                                                                                <tr key={index}>
                                                                                    <td>{index + 1}</td>
                                                                                    <td>{jsonObj.file_name}</td>
                                                                                    <td>{jsonObj.file_size}</td>
                                                                                    <td>{jsonObj.upload_size}</td>
                                                                                    <td>{jsonObj.status}</td>
                                                                                </tr>
                                                                            ))}
                                                                    </tbody>
                                                                </table>
                                                            ) : (
                                                                <div className="text-center p-3">
                                                                    <h5 className="text-muted">No data available for this report.</h5>
                                                                </div>
                                                            )}
                                                        </CardBody>
                                                        <CardFooter>
                                                            <button
                                                                type="button"
                                                                className="btn btn-secondary"
                                                                onClick={() => setViewDetailsReportId(null)}
                                                            >
                                                                Close
                                                            </button>
                                                        </CardFooter>
                                                    </Card>
                                                </Modal>
                                            </React.Fragment>}
                                    </div>
                                </td>
                            </tr>
                        ))) : (
                            <tr>
                                <td colSpan={4} className="p-3 text-center">
                                    <Message message="No completed reports available at the moment." type="danger" width="500px" />
                                </td>
                            </tr>
                        )}
                    </tbody>
                    <tfoot>
                        {page?.length > 0 &&
                            <tr>
                                <td colSpan={5} className="p-2">
                                    <PageNavButton
                                        setPageUrl={setPageURL}
                                        pageobj={displayData}
                                        pageUrl={pageURL}
                                        isLoading={reportsFetching}
                                    />
                                </td>
                            </tr>
                        }
                    </tfoot>
                </table>
            )}
            {hoverId !== null &&
                <ToolTip
                    target={hoverId?.includes('Extra') ? extraActionsTooltipRef : hoverId}
                    message={formattooltip(hoverId)}
                    isOpen={hoverId !== null}
                />
            }
            {/* {deletePopOverState &&
                <DeletePopOver
                    target={deleteTarget}
                    onClick={async () => {
                        await handleDeleteReport(deleteReportObj, setRefreshKey, setDeletePopOverState, false)?.then(() => {
                            queryClient.invalidateQueries(queryKeyes.edit.checkongoingReport.key);
                            queryClient.invalidateQueries(queryKeyes.edit.checkEditPermission.key);
                            queryClient.invalidateQueries(queryKeyes.pagination.completeReportPage.key);
                            queryClient.invalidateQueries(queryKeyes.vessel.LastVesselReport.key);
                        });
                        setHoverId(null);
                    }}
                    state={deletePopOverState}
                    setState={setDeletePopOverState}
                />
            } */}
            {PopOverState && reportId !== 0 &&
                <PopOver
                    state={PopOverState}
                    setState={setPopOverState}
                    message={'Are you sure you want to send email ?'}
                    target={`send_email_${reportId}`}
                    handleClick={() => {
                        sendEmail(vesselId, reportId);
                    }}
                />
            }
            <Modal
                isOpen={emailRecipientModal}
                toggle={() => {
                    setEmailRecipientModal(false)
                    setShowAddEmail(false);
                    setAddEmailButton(true);
                    setSelectedRecipients([]);
                    addEmailFormik.resetForm();
                }}
                centered
                size="lg"
            >
                <div className="p-4">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="mb-0">Select Recipients</h5>
                        <Button
                            close
                            onClick={() => {
                                setShowAddEmail(false);
                                setAddEmailButton(true);
                                setEmailRecipientModal(false)
                                setSelectedRecipients([]);
                                addEmailFormik.resetForm();
                            }}
                            aria-label="Close"
                        />
                    </div>
                    <div className='p-3'>
                        {emailList.length > 0 ? (
                            emailList.map((user: any, idx: number) => (
                                <div
                                    key={user.email + idx}
                                    className="d-flex align-items-center justify-content-between py-2 px-2 rounded hover-bg-light"
                                >
                                    <div className="d-flex align-items-center">
                                        <Input
                                            type="checkbox"
                                            id={`email_${idx}`}
                                            checked={selectedRecipients.includes(idx)}
                                            onChange={e => {
                                                if (e.target.checked) {
                                                    setSelectedRecipients(prev => [...prev, idx]);
                                                } else {
                                                    setSelectedRecipients(prev => prev.filter(id => id !== idx));
                                                }
                                            }}
                                        />
                                        <Label className="ms-2 mb-0 fw-semibold" style={{ cursor: "pointer" }} for={`email_${idx}`}>
                                            {user.name}
                                        </Label>
                                    </div>
                                    <small className="text-muted">{user.email}</small>
                                </div>
                            ))
                        ) : (
                            <p className="text-muted text-center my-3">
                                No recipients available.
                            </p>
                        )}
                    </div>
                    {addEmailButton &&
                        <div className="m-2 d-flex justify-content-end">
                            <BaseButton
                                title="Add"
                                variant="primary"
                                icon={<i className="dripicons-plus me-1" />}
                                onClick={() => {
                                    setShowAddEmail(!showAddEmail);
                                    setAddEmailButton(false);
                                }}
                            />
                        </div>
                    }
                    {showAddEmail && (
                        <form onSubmit={addEmailFormik.handleSubmit} className="border rounded p-3 mb-3">
                            <Row>
                                <Col md={4}>
                                    <div className="position-relative">
                                        <Input
                                            id="addEmailName"
                                            name="name"
                                            placeholder="Name"
                                            value={addEmailFormik.values.name}
                                            onChange={addEmailFormik.handleChange}
                                            onBlur={addEmailFormik.handleBlur}
                                        />
                                        {env?.form_validation && (
                                            <ErrorTooltip
                                                target="addEmailName"
                                                message={addEmailFormik.errors.name}
                                                open={!!(addEmailFormik.errors.name && addEmailFormik.touched.name)}
                                            />
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="position-relative">
                                        <Input
                                            id="addEmailAddress"
                                            name="email"
                                            placeholder="Email"
                                            value={addEmailFormik.values.email}
                                            onChange={addEmailFormik.handleChange}
                                            onBlur={addEmailFormik.handleBlur}
                                        />
                                        {env?.form_validation && (
                                            <ErrorTooltip
                                                target="addEmailAddress"
                                                message={addEmailFormik.errors.email}
                                                open={!!(addEmailFormik.errors.email && addEmailFormik.touched.email)}
                                            />
                                        )}
                                    </div>
                                </Col>
                            </Row>
                            <div className="d-flex justify-content-end mt-2">
                                <BaseButton
                                    type="submit"
                                    title="Save"
                                    variant="success"
                                    className="ms-2"
                                    disabled={!(addEmailFormik.isValid && addEmailFormik.dirty)}
                                />
                            </div>
                        </form>
                    )}
                    <div className="d-flex justify-content-end mt-4">
                        <Button
                            color="primary"
                            className="ms-2"
                            onClick={() => {
                                // Send selected email objects (by index)
                                const selectedEmails = selectedRecipients.map(idx => emailList[idx]);
                                // TODO: Replace with actual send logic
                                handleSendEmailToRecipients(selectedEmails);
                            }}
                            disabled={selectedRecipients.length === 0}
                        >
                            Send Email
                        </Button>
                    </div>
                </div>
            </Modal>
            {
                insertReport &&
                <PopUp
                    state={insertReport}
                    setState={setInsertReport}
                    body={<InsertReportPopUp />}
                    title={'Add Report'}
                    size={'lg'}
                />
            }
            {/* {
                deleteVoyageReport &&
                <PopUp
                    state={deleteVoyageReport}
                    setState={setDeleteVoyageReport}
                    title="Delete Voyage"
                    body={
                        <DeleteVoyagePopUp
                            voyage={voyage}
                            setDeleteVoyagePopup={setDeleteVoyageReport}
                            deleteReportObj={deleteReportObj}
                            setRefreshKey={setRefreshKey}
                            setDeletePopOverState={setDeletePopOverState}
                        />
                    }
                    size="sm"
                />
            }
             {
                changeVoyageBool &&
                <PopUp
                    state={changeVoyageBool}
                    setState={setChangeVoyageBool}
                    title="Change Voyage"
                    size="sm"
                    body={
                        <React.Fragment>
                            <Row className='mb-2'>
                                <Col lg={12}>
                                    <p className='mb-2'>Current voyage: <strong>{voyage?.voyage_number}</strong></p>
                                    <p>New voyage: <strong>{updatedVoyage?.voyage?.voyage_number}</strong></p>
                                </Col>
                            </Row>
                            {allReports && allReports?.count === 1 &&
                                <Row className='mb-2'>
                                    <Col lg={9}>
                                        <p>Do you want to delete the voyage as well?</p>
                                    </Col>
                                    <Col lg={3}>
                                        <div className="square-switch mt-1">
                                            <Input
                                                type="checkbox"
                                                switch="none"
                                                id={`delete_voyage`}
                                                name={`delete_voyage`}
                                                onChange={(e: any) => setDeleteVoyage(e.target.checked)}
                                            />
                                            <Label
                                                htmlFor="delete_voyage"
                                                data-on-label="Yes"
                                                data-off-label="No"
                                                className="mt-1"
                                                tabIndex={0}
                                                onKeyDown={(e) => {
                                                    if (e.key === " " || e.key === "Enter") {
                                                        e.preventDefault();
                                                        document.getElementById("delete_voyage")?.click();
                                                    }
                                                }}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            }
                            <Button
                                type="button"
                                color="primary"
                                className="btn_size_cstm justify_right"
                                onClick={() => {
                                    if (deleteVoyage) {
                                        apiGlobal.post(`/shift_report_to_voyage/`, {
                                            report_id: reportId,
                                            delete_empty_voyage: true
                                        }).then(async res => {
                                            if (res?.status === 200) {
                                                successToast("Voyage changed successfully!");
                                                setChangeVoyageBool(false);
                                                setDeleteVoyage(false);
                                                dispatch(setVesselState("VOYAGE_REPORTING"));
                                                await queryClient.invalidateQueries(queryKeyes.pagination.completeReportPage.key);
                                                await queryClient.invalidateQueries(queryKeyes.vessel.LastVesselReport.key);
                                            }
                                        }).catch(() => {
                                            errorToast("Error changing voyage!");
                                            setChangeVoyageBool(false);
                                            setDeleteVoyage(false);
                                        });
                                    } else {
                                        apiGlobal.post(`/shift_report_to_voyage/`, {
                                            report_id: reportId,
                                        }).then(async res => {
                                            if (res?.status === 200) {
                                                successToast("Voyage changed successfully!");
                                                setChangeVoyageBool(false);
                                                setDeleteVoyage(false);
                                                await queryClient.invalidateQueries(queryKeyes.pagination.completeReportPage.key);
                                                await queryClient.invalidateQueries(queryKeyes.vessel.LastVesselReport.key);
                                            }
                                        }).catch(() => {
                                            errorToast("Error changing voyage!");
                                            setChangeVoyageBool(false);
                                        });
                                    }
                                }}
                            >
                                Change Voyage
                            </Button>
                        </React.Fragment>
                    }
                />
            }
            {
                changeVoyageErrorBool &&
                <PopUp
                    state={changeVoyageErrorBool}
                    setState={setChangeVoyageErrorBool}
                    size="sm"
                    title="Error"
                    body={<Message type="danger" message="This report's voyage cannot be changed!" />}
                />
            } */}
            <PopUp
                state={unLockBool}
                setState={setUnlockBool}
                title={`${UnlockMode === 'edit' ? 'Edit' : 'Insert New'} Report`}
                body={
                    <EditPermissionPopUP
                        unlockReport={() => unlockReport(reportid)}
                        unlockMode={UnlockMode}
                        setState={setUnlockBool}
                        isOngoingReport={isOngoingReport}
                        isEditing={!isEditing}
                    />
                }
                size='md'
            />
            <ViewReportModal
                state={viewReport}
                setState={setViewReport}
                vesselId={VesselID}
                reportId={reportId}
                modalId={`${VesselID}${reportId}`}
            />
            <PopUp
                state={importStatus}
                setState={setImportStatus}
                title={`Check Edit Status`}
                size='md'
                body={
                    <ImportStatusReport reportId={reportId} />
                }
            />
            <PopUp
                state={fileModelBool}
                setState={setFileModelBool}
                title={
                    <React.Fragment>
                        <h4 className="mb-0">File Syncing Status</h4>
                    </React.Fragment>
                }
                body={
                    <React.Fragment>
                        <h5 className="mb-0">Report: {currentReport?.reporting_event_name}</h5>
                        <p className='mb-2'>
                            Date: {currentReport && currentReport?.local_time?.slice(0, 10)} {currentReport && currentReport?.local_time?.slice(11, 16)}
                        </p>
                        {offlineFileStatus && offlineFileStatus?.some((jsonObj: any) => jsonObj?.vessel_reporting_information === currentReport?.id) ? (
                            <table className="table table-bordered table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">File Name</th>
                                        <th scope="col">File type</th>
                                        <th scope="col">Total Size</th>
                                        <th scope="col">Upload Size</th>
                                        <th scope="col">Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {offlineFileStatus
                                        ?.filter((jsonObj: any) => jsonObj.vessel_reporting_information === currentReport?.id)
                                        ?.map((jsonObj: any, index: number) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{jsonObj.file_name}</td>
                                                <td>{fileTypeConstant[jsonObj.file_type_constant]}</td>
                                                <td>{
                                                    jsonObj.file_size
                                                        ? jsonObj.file_size > 1024 * 1024
                                                            ? `${(jsonObj.file_size / (1024 * 1024)).toFixed(2)} MB`
                                                            : `${(jsonObj.file_size / 1024).toFixed(2)} KB`
                                                        : '- KB'
                                                }
                                                </td>
                                                <td>{`${jsonObj.uploaded_size
                                                    ? jsonObj.uploaded_size > 1024 * 1024
                                                        ? `${(jsonObj.uploaded_size / (1024 * 1024)).toFixed(2)} MB`
                                                        : `${(jsonObj.uploaded_size / 1024).toFixed(2)} KB`
                                                    : '- KB'
                                                    } (${((jsonObj.uploaded_size / jsonObj.file_size) * 100).toFixed(2)}%)`}</td>
                                                <td>{jsonObj.status}</td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        ) : (
                            <div className="text-center p-3">
                                <h5 className="text-muted">No data available for this report.</h5>
                            </div>
                        )}
                    </React.Fragment>
                }
                size="xl"
            />
            {
                requestEditBool &&
                <PopUp
                    state={requestEditBool}
                    setState={setRequestEditBool}
                    body={
                        <GrantEditAccess
                            handleOfflineEditAccess={handleOfflineEditAccess}
                            VesselData={VesselData}
                            onClose={() => setRequestEditBool(false)}
                        />
                    }
                    title={'Alert'}
                    size='lg'
                />
            }
        </CardBody >
    )
}

export default CompletedReports;